import * as React from 'react';
import { SVGProps } from 'react';

export const InfoCircleBigIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="info-circle-big-icon"
    {...props}
  >
    <g id="info-circle">
      <path
        id="Vector"
        opacity="0.4"
        d="M12 22.0005C17.5228 22.0005 22 17.5233 22 12.0005C22 6.47764 17.5228 2.00049 12 2.00049C6.47715 2.00049 2 6.47764 2 12.0005C2 17.5233 6.47715 22.0005 12 22.0005Z"
        fill="black"
      />
      <path
        id="Vector_2"
        d="M12 17.2505C11.586 17.2505 11.25 16.9145 11.25 16.5005V11.9294C11.25 11.5154 11.586 11.1794 12 11.1794C12.414 11.1794 12.75 11.5154 12.75 11.9294V16.5005C12.75 16.9145 12.414 17.2505 12 17.2505ZM13.02 8.50049C13.02 7.94849 12.573 7.50049 12.02 7.50049H12.01C11.458 7.50049 11.0149 7.94849 11.0149 8.50049C11.0149 9.05249 11.468 9.50049 12.02 9.50049C12.572 9.50049 13.02 9.05249 13.02 8.50049Z"
        fill="black"
      />
    </g>
  </svg>
);
